<template>
  <v-alert
    class="my-0"
    style="cursor: pointer"
    dense
    :outlined="!!value ? false : true"
    :color="!!value ? 'green' : 'grey'"
    :type="!!value ? 'success' : null"
    @click="onChangeOnlyNewStatus(!value)"
  >
    <div>{{ label }}</div>
  </v-alert>
</template>

<script>
export default {
  name: 'PreMadeFilter',
  props: {
    value: Boolean,
    label: String,
  },
  methods: {
    onChangeOnlyNewStatus(value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="less" scoped></style>
